import { axios } from "~/plugins/request"
export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  selectProduct({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('productManage/selectProduct', params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findProductById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`productManage/customerId`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  productSave({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`productManage/productSave`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteProduct({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`productManage/deleteProduct`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
